import Cookies from "js-cookie"
import { call, put, select } from "redux-saga/effects"
import URI from "urijs"

import api from "apis"
import { toggleFullLoading } from "app-store-v2/actions"
import { IS_JEWLR } from "helpers/application"
import getJewlrCountries from "site-data/jewlr/countries"
import getPortalCountries from "site-data/portal/countries"

export default function* switchCountry(action) {
  const countries = IS_JEWLR() ? getJewlrCountries() : getPortalCountries()
  const { country } = action
  const state = yield select()
  const cart_token = Cookies.get(sl.config.cookies_config.cart_token)
  const countryData = countries.find(({ geo }) => geo === country)

  if (countryData.site_country != "int") {
    const url = `/api/v10/cart/${cart_token}/country/${country}`

    yield put(toggleFullLoading(true))

    try {
      const response = yield call(api.get, url)
      if (response?.data?.token) {
        const { cookie_key, token } = response.data
        if (cookie_key && token) {
          Cookies.set(cookie_key, token, { expires: 365, secure: true })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (countryData) {
    const { pathname, search, hash } = state.router.location
    const subdomain =
      sl.config.env === "production" ? (IS_JEWLR() ? "www" : "") : sl.config.env
    const separator = IS_JEWLR() ? "." : ""
    const domain =
      sl.config.env === "development"
        ? `${sl.config.site_url}`
        : `${subdomain}${separator}${countryData.url}`
    const uri = new URI(`https://${domain}${pathname}${search}${hash}`)
    uri.removeQuery("geo").addQuery({ geo: country }).removeQuery("locale")
    window.location.href = uri.toString()
  }
}
